module.exports = __webpack_public_path__ + "img/5db.3ee24fbd.jpg";